import { gql } from 'graphql-request'

export const CHECK_BOOKMARK = gql`
  query IsBookmarked($bookChapterId: Int!) {
    isBookmarked(bookChapterId: $bookChapterId)
  }
`
